module.exports = __webpack_public_path__ + "3.png?a818934b78c55ae98c1f3b47ba5228ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartoon/3.png
// module id = 208
// module chunks = 0